module.exports = ".c-option--available {\n  padding: 1em 0.5em;\n  border-bottom: 1px solid #ddd;\n}\n.card .desc {\n  font-size: 0.875em;\n  color: #555;\n  text-align: justify;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/faction/faction.component.less
// module id = ./src/app/faction/faction.component.less
// module chunks = main